/**
 * Anchor ids for help content, extracted so both the renderer and the search
 * index can derive the same fragment without one importing the other (the
 * renderer pulls in React and the router; the search module must stay pure).
 */

/** Stable anchor id for a heading — also the TOC link target. */
export function headingId(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}
